import {HTMLProps} from 'react';

interface IProps extends HTMLProps<HTMLElement> {}

export default function RedDot({className, ...props}: IProps) {
  return (
    <i
      className={cn(className, 'bg-red rounded-50per absolute h-4 w-4')}
      {...props}
    />
  );
}
